import { FC } from 'react';
import { createPortal } from 'react-dom';
import style from './CarChangeListStyle.module.css';
import { PopupTemplate } from '@/components/uiParts/Template/PopupTemplate/PopupTemplate';
import { store } from '@/config/store';
import { Affiliate } from '@/types/api/authApi';
import { Car } from '@/types/api/customerApi';
import { carNameTitle } from '@/utils/home';
import { getCarPhoto } from '@/utils/utils';

interface CarChangeListProps {
  isOpenCarList: boolean;
  selectedCar?: Car;
  affiliatesInfo: Affiliate[];
  changeIsOpenCarList: (bool: boolean) => void;
  handleClickListImage: (
    car: Affiliate['cars'][0] | null,
    affiliateID: number,
  ) => Promise<void>;
  handleClickRegistCar: () => void;
}
export const CarChangeList: FC<CarChangeListProps> = ({
  isOpenCarList,
  selectedCar,
  affiliatesInfo,
  changeIsOpenCarList,
  handleClickListImage,
  handleClickRegistCar,
}) => {
  const isSelected = (car: Affiliate['cars'][0], affiliateId: number) => {
    if (!selectedCar) return false;
    if (affiliateId !== store.state.customerInfo.id) return false;
    return selectedCar.m_car_id != null
      ? selectedCar.m_car_id === car.m_car_id
      : selectedCar.t_order_id === car.t_order_id;
  };

  const popup = (
    <PopupTemplate
      id="ResendSms"
      opened={isOpenCarList}
      handleClose={() => changeIsOpenCarList(false)}
      onPopupClosed={() => changeIsOpenCarList(false)}
      title="車両切り替え"
    >
      <div className={style['wrapper']}>
        <div className={style['container']}>
          {affiliatesInfo.map((affiliate) => (
            <div
              className={
                store.state.globalTheme == null ? style['car-card-wrapper'] : ''
              }
              key={affiliate.id}
            >
              {store.state.globalTheme == null && affiliatesInfo.length > 1 && (
                <p className={style['affiliate-name']}>
                  {affiliate.affiliate_name}
                </p>
              )}
              {!affiliate.cars.length && (
                <div
                  className={style['car-card']}
                  onClick={() => handleClickListImage(null, affiliate.id)}
                >
                  <div
                    className={`${style['selection-indicator']} ${
                      store.state.authInfo.m_customer_id === affiliate.id
                        ? style['selected']
                        : ''
                    }`}
                  >
                    <i className={`icon-check ${style['check-icon']}`} />
                  </div>
                  <div className={style['car-image-wrapper']}>
                    <img src={getCarPhoto()} />
                  </div>
                  <div className={style['car-information-wrapper']}>
                    <span className={style['car-information-title']}>
                      契約中車両はありません
                    </span>
                  </div>
                </div>
              )}
              {affiliate.cars.map((car) => {
                const selected = isSelected(car, affiliate.id);
                const plateNumber = [
                  car.class_no,
                  car.hiragana,
                  car.registry_no,
                ]
                  .filter(Boolean)
                  .join(' ');
                return (
                  <div
                    className={style['car-card']}
                    key={car.m_car_id || car.t_order_id}
                    onClick={() => handleClickListImage(car, affiliate.id)}
                  >
                    <div
                      className={`${style['selection-indicator']} ${
                        selected ? style['selected'] : ''
                      }`}
                    >
                      <i className={`icon-check ${style['check-icon']}`} />
                    </div>
                    <div className={style['car-image-wrapper']}>
                      <img src={getCarPhoto(car)} />
                    </div>
                    <div className={style['car-information-wrapper']}>
                      <span className={style['car-information-title']}>
                        {carNameTitle(
                          true,
                          true,
                          car?.car_nm || '現在契約中の車両はありません',
                        )}
                      </span>
                      {plateNumber && (
                        <span className={style['car-information-number']}>
                          {plateNumber}
                        </span>
                      )}
                      {selected && !!car.warranties?.length && (
                        <span className={style['warranty-badge']}>
                          {car.warranties[0]?.warranty_name}
                        </span>
                      )}
                    </div>
                    <span className={style['alert-icon']}>!</span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className={style['footer']}>
          <button
            className={style['register-button']}
            onClick={() => {
              changeIsOpenCarList(false);
              handleClickRegistCar();
            }}
          >
            新規登録
          </button>
        </div>
      </div>
    </PopupTemplate>
  );
  // Framework7 moves an opened Popup to the app root. Mount it there from the
  // beginning so React can safely unmount Home while switching customers.
  const appRoot = document.querySelector('.framework7-root');
  return appRoot ? createPortal(popup, appRoot) : popup;
};
